'use strict';

var utils = require('@liquorice/utils');
var fragmentMasking = require('./types/fragment-masking.js');

/**
 * Extracts the data from a fragment or a mixed array of fragments | null | undefined,
 * and returns an array of valid data
 *
 * @param fragment The fragment definition
 * @param data The fragment(s) to extract data from
 * @returns An array of valid data
 */ function toFragmentDataArray(fragment, data) {
    // Create an array of valid data
    const dataArr = utils.makeNonNullableArray(data);
    // Return the array of extracted fragment data
    return fragmentMasking.getFragmentData(fragment, dataArr);
}

module.exports = toFragmentDataArray;
